<template>
  <div>
    <GenericReport
      ref="report"
      class="clean-list"
      hide-header
      orientation="horizontal"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      :extraParams="{ keyboardId }"
      @rowClicked="showRowDetails"
    >
      <template v-slot:topbar-actions>
        <HistoryRecordDialog ref="dialog" />
        <v-btn color="primary" @click="newItem">
          Novo Registro...
        </v-btn>
      </template>
    </GenericReport>
  </div>
</template>

<script>
import EditStore from './EditStore'
import { Keyboard } from '@/models'
import { preProcessSpec } from 'oderon-commons/src/tables'
import fmt from 'oderon-commons/src/formatters'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import HistoryRecordDialog from './HistoryRecordDialog.vue'

export default {
  components: { GenericReport, HistoryRecordDialog },
  data() {
    return {
      EditStore,

      reportSpec: {
        code: 'keyboardHistory'
      },

      adapterSpec: preProcessSpec({
        defaultSortable: false,
        columns: [
          { t: 'ID|', d: 'id', w: 50, selectable: true },
          {
            t: 'Data|',
            d: 'timestamp',
            f: fmt.brDateTime,
            w: 180
          },
          { t: '|Tipo|', d: 'type', w: 150 },
          { t: 'Veículo', d: 'vehicle.code', w: 150 },
          { t: 'Técnico', d: 'technician.name', w: 150 },
          { t: 'Centro de Custo', d: 'costCenter.name', w: 150 },
          { t: 'Login', d: 'login', w: 150 },
          { t: 'Comentários', d: 'comments', w: 150 }
        ]
      })
    }
  },
  computed: {
    keyboardId() {
      return EditStore.row.id
    },
    currentTab() {
      return EditStore.currentTab
    }
  },
  watch: {
    currentTab: {
      handler(x) {
        if (x == 'history') this.reload()
      }
      // immediate: true
    }
  },
  methods: {
    reload() {
      this.$loading(() => this.$refs.report.reload())
    },

    async fetchData(apiParams) {
      return await Keyboard.findHistory(EditStore.row.id, apiParams)
    },

    async showRowDetails({ row }) {
      let res = await this.$refs.dialog.open(row.id, this.keyboardId)
      if ( res != null ) this.$refs.report.reload()
    },

    async newItem() {
      let res = await this.$refs.dialog.open(null, this.keyboardId)
      if ( res != null ) this.$refs.report.reload()
    }
  }
}
</script>

<style></style>
